// src/api/axios.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  validateStatus: status => status < 500, // ⭐ 4xx도 then으로
});

api.interceptors.response.use(
  res => res,
  err => {
    const status = err?.response?.status;

    // 상태만 정리, 이동 ❌
    if (status === 410) {
      localStorage.removeItem('gateToken');
    }

    return Promise.reject(err);
  }
);

export default api;
